import { render } from "./RegisterShop.vue?vue&type=template&id=55494b21&scoped=true"
import script from "./RegisterShop.vue?vue&type=script&lang=js"
export * from "./RegisterShop.vue?vue&type=script&lang=js"

import "./RegisterShop.vue?vue&type=style&index=0&id=55494b21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55494b21"]])

export default __exports__